<template>
  <span>
    {{ formatCurrency(object.paidSum) }}
    <div v-if="object.refundedSum" class="text-danger small">{{ $t('return') }}: {{ formatCurrency(object.refundedSum) }}</div>
  </span>
</template>

<script setup>
import {formatCurrency} from "@/extensions/filters/filters"

defineProps({
  object: {
    type: Object
  }
})
</script>
